import _ from "lodash";

import { float6Normalizer } from "validators";

export const interchangePlusMapper = (
	FORM_NAME,
	dispatch,
	change,
	feeTemplate,
) => {
	const findInterchangePlusFormValue = _.filter(
		feeTemplate.fieldBlocks,
		item => item.name === "InterchangePlus",
	);

	if (_.isEmpty(findInterchangePlusFormValue)) return;

	const findInterchangePlusAuthorizationFeeValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{ name: "interchangePlusAuthorizationFee" },
	);

	const findInterchangePlusVMCDValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "interchangePlusVMCD",
		},
	);

	const findInterchangePlusOfflineDebitValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "interchangePlusOfflineDebit",
		},
	);

	const findInterchangePlusSalesTransactionFeeValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "interchangePlusSalesTransactionFee",
		},
	);

	const findInterchangePlusAmexValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "interchangePlusAmex",
		},
	);

	const findCommercialCardInterchangeServiceFee = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "commercialCardInterchangeServiceFee",
		},
	);

	const findPassCardBrandFeesValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "passCardBrandFees",
		},
	);

	const findInterchangePlusRevenueTypeValue = _.find(
		findInterchangePlusFormValue[0].fields,
		{
			name: "interchangePlusRevenueType",
		},
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusAuthorizationFee",
			float6Normalizer(findInterchangePlusAuthorizationFeeValue?.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusVMCD",
			float6Normalizer(findInterchangePlusVMCDValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusOfflineDebit",
			float6Normalizer(findInterchangePlusOfflineDebitValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusSalesTransactionFee",
			float6Normalizer(
				findInterchangePlusSalesTransactionFeeValue?.value,
			),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusAmex",
			float6Normalizer(findInterchangePlusAmexValue.value),
		),
	);
	dispatch(
		change(
			FORM_NAME,
			"commercialCardInterchangeServiceFee",
			float6Normalizer(findCommercialCardInterchangeServiceFee.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"passCardBrandFees",
			findPassCardBrandFeesValue.value,
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusRevenueType",
			findInterchangePlusRevenueTypeValue.value,
		),
	);
};
